import { Box, Menu, MenuItem, Typography } from '@mui/material';
import {
  // Route,
  List,
  Clock,
  MapIcon,
  Route,
  Store} from "lucide-react";
import { LinkMenuItem } from './LinkMenuItem';

interface Props {
  dateMenuAnchor: HTMLElement | null;
  handleDateMenuClose: () => void;
  selectedDate: Date | null;
}

export const LinkMenu = ({
  dateMenuAnchor,
  handleDateMenuClose,
  selectedDate,
}: Props) => {
  {/* 日付選択メニュー */}
  return (
    <Menu
      anchorEl={dateMenuAnchor}
      open={Boolean(dateMenuAnchor)}
      onClose={handleDateMenuClose}
      slotProps={{
        paper: {
          sx: {
            mt: 1,
            boxShadow: 3,
            borderRadius: 2,
            minWidth: 250,
            p: 0,
          }
        }
      }}
    >
      <MenuItem
        disabled
        sx={{
          opacity: 1,
          cursor: "default",
          "&:hover": { bgcolor: "transparent" }
        }}
      >
        <Typography variant="subtitle2" fontWeight="bold" color="primary.main">
          {selectedDate && `${selectedDate.getFullYear()}年${selectedDate.getMonth() + 1}月${selectedDate.getDate()}日`}
        </Typography>
      </MenuItem>
      <Box sx={{ px: 2, py: 1 }}>
        <Typography variant="caption" color="text.secondary">
          以下から選択してください
        </Typography>
      </Box>

      <LinkMenuItem
        path="shipment-orders"
        selectedDate={selectedDate}
        primaryText="案件一覧"
        secondaryText="伝票・配送指示を確認"
        icon={<List size={18} />}
      />

      <LinkMenuItem
        path="plans"
        selectedDate={selectedDate}
        primaryText="配車計画（マップ）"
        secondaryText="地図上で配車状況を確認"
        icon={<MapIcon size={18} />}
      />

      <LinkMenuItem
        path="timeline"
        selectedDate={selectedDate}
        primaryText="配車計画（タイムライン）"
        secondaryText="時間軸で配車スケジュールを確認"
        icon={<Clock size={18} />}
      />

      <LinkMenuItem
        path="convenience-dispatches"
        selectedDate={selectedDate}
        primaryText="配車計画（カード）"
        secondaryText="固定コース・当日配車を管理"
        icon={<Store size={18} />}
        beta
      />

      <LinkMenuItem
        path="lanes"
        selectedDate={selectedDate}
        primaryText='レーン管理'
        secondaryText="車両割当・レーン設定を確認"
        icon={<Route size={18} />}
        beta
      />
    </Menu>
  );
};
